import { Routes } from '@angular/router';
import { LoginPage } from '../components/loggedOff/login-page/login-page';
import { AdminPage } from '../components/admin/admin-page/admin-page';
import { InfoPage } from '../components/loggedOff/info-page/info-page';
import { RsvpPage } from '../components/user/rsvp-page/rsvp-page';
import { adminGuard } from '../guards/admin-guard';
import { Import } from '../components/admin/import/import';
import { Display } from '../components/admin/display/display';
import { Dashboard } from '../components/admin/dashboard/dashboard';
import { QrLanding } from '../components/user/qr-landing/qr-landing';
import { EditFaq } from '../components/admin/edit-faq/edit-faq';
import { FaqPage } from '../components/loggedOff/faq-page/faq-page';
import { HomePage } from '../components/loggedOff/home-page/home-page';
import { Planning } from '../components/loggedOff/planning/planning';
import { Invitations } from '../components/admin/invitations/invitations';
import { Notifications } from '../components/admin/notifications/notifications';
import { Legal } from '../components/common/legal/legal';

export const routes: Routes = [
{
    path: '',
    component: HomePage,
    title: 'Page d\'accueil'
  },
  {
    path: 'login',
    component: LoginPage,
    title: 'Login'
  },
  {
    path: 'admin',
    component: AdminPage,
    title: 'Admin',
    canActivate: [adminGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'import',
        component: Import,
        title: 'Importer',
        canActivate: [adminGuard],
      },
      {
        path: 'dashboard',
        component: Dashboard,
        title: 'Dashboard',
        canActivate: [adminGuard],
      },
      {
        path: 'display',
        component: Display,
        title: 'Tableau',
        canActivate: [adminGuard],
      },
      {
        path: 'edit-faq',
        component: EditFaq,
        title: 'Modifier FAQ',
        canActivate: [adminGuard],
      },
      {
        path: 'notifs',
        component: Notifications,
        title: 'Notifications',
        canActivate: [adminGuard],
      }
    ]
  },
  {
    path: 'info',
    component: InfoPage,
    title: 'Informations'
  },
  {
    path: 'faq',
    component: FaqPage,
    title: 'FAQ'
  },
  {
    path: 'rsvp',
    component: RsvpPage,
    title: 'RSVP'
  },
  {
    path: 'qr-code',
    component: QrLanding,
    title: 'Scanned QR Code'
  },
  {
    path: 'planning',
    component: Planning,
    title: 'Planning'
  },
  {
    path: 'legals',
    component: Legal,
    title: 'Mentions Légales'
  }
];
